<template>
    <transition name="fade">
        <section
            v-show="galleryItems"
            :class="['zoom-gallery', { loading }]"
            @click="$store.dispatch('CLOSE_GALLERY')"
        >
            <div class="contained">
                <super-image
                    class="image"
                    v-for="(url, i) in galleryItems"
                    @click.stop
                    :src="url"
                    :key="i"
                />
            </div>
        </section>
    </transition>
</template>

<script>
import imagesLoaded from 'imagesloaded'
import { styler } from 'popmotion'

export default {
    watch: {
        async galleryItems(items, prev) {
            this.loading = true

            // if we haad items and did not before...
            if (items && !prev) {
                const focus = this.$store.state.galleryFocus
                if (focus > -1) {
                    // wait for render
                    await this.$nextTick()

                    // wait for image load
                    imagesLoaded(this.$el, () => {
                        // find image and scroll to it
                        const s = styler(this.$el)
                        const images = [...this.$el.querySelectorAll('.image')]
                        const targetImage = images[focus]
                        s.set('scrollTop', targetImage.offsetTop - 50)

                        // set loading
                        this.loading = false
                    })
                }
            }
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        galleryItems() {
            return this.$store.state.gallery
        }
    }
}
</script>

<style lang="scss">
@import 'src/scss/mixins';

.zoom-gallery {
    background-color: rgba(#fff, 0.85);
    position: fixed;
    overflow: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    z-index: 5;

    .image {
        transition: opacity 500ms ease;
        margin-bottom: 50px;
    }
    &.loading .image {
        opacity: 0;
    }
    .contained {
        padding-top: 50px;
        max-width: 880px;
        margin: auto;
    }

    // transition
    &.fade-enter-active,
    &.fade-leave-active {
        transition: opacity 400ms;
    }
    &.fade-enter,
    &.fade-leave-to {
        opacity: 0;
    }

    // mobile
    @include bp(s) {
        display: none;
    }
}
</style>
